export default "__VITE_ASSET__Coo3_SoY__"